export default __webpack_public_path__ + "static/media/weather.18ee5932.png";